// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"74393ff4","453":"f3ee3a5d"}[chunkId] + ".chunk.js";
};